import React from 'react';
import Container from '../Layout/Container';
import { Box } from '../Layout';
import { Link } from '../Typography';

const Support = () => (
  <Container>
    <Box>
      <h1>Support</h1>
      <h2>Partners</h2>
      <p>Support from the following organisations allows us to provide opportunities across Australia:</p>
      <p><Link href='https://asf.org.au/'>Australian Sports Foundation</Link></p>
      <p><Link href='https://www.paralympic.org.au/'>Australian Paralympic Committee </Link></p>
      <p><Link href='https://www.blindsportsnsw.com.au/home/'>Blind Sports NSW</Link></p>
      <p><Link href='https://www.footballvictoria.com.au/'>Football Victoria</Link></p>
      <p><Link href='http://blindsports.org.au/'>Blind Sports and Recreation Victoria</Link></p>
      <p><Link href='http://www.web-foot.com.au/committees/wa-blind-sports-federation/'>Western Australia Blind Sports Federation</Link></p>
      <p><Link href='http://footballwest.com.au/'>Football West </Link></p>
      <p><Link href='https://www.unitedabilities.org.au/'>United Abilities</Link></p>
      <h2>Donate</h2>
      <p>Throughout the year we run a number of fundraising campaigns to support development of blind football.</p>
      <p>You can donate anytime via:</p>
      <p><Link href='https://asf.org.au/projects/australian-blind-football/'>https://asf.org.au/projects/australian-blind-football/</Link></p>
      <p>You can donate once, or set up regular donations.</p>
      <h2>ABF Apparel</h2>
      <p>Through a partnership with Macron you can purchase your very own ABF Apparel. A percentage of all purchases go towards development of blind and partially sigted football initiatives.</p>
      <p>You can purchase apparel from our Macron store:</p>
      <p><Link href='https://macronvic.com.au/collections/aus-blind-football/'>https://macronvic.com.au/collections/aus-blind-football/</Link></p>
      <h2>Sponsors</h2>
      <p>If you are interested in sponsoring Australian Blind Football, or have a specific interest in becoming a team sponsor for our Blind Football or Partially Sighted Futsal teams, please email <Link
        href='mailto:football@blindsportsaustralia.com'
        target='_top'
        aria-label='Email Blind Sports Australia'
      >football@blindsportsaustralia.com
      </Link>.
      </p>
      <h2>Volunteer</h2>
      <p>We love to have the help of volunteers. If you are interested in volunteering locally, at one of our national training centres or at a national camp you can email <Link
        href='mailto:football@blindsportsaustralia.com'
        target='_top'
        aria-label='Email Blind Sports Australia'
      >football@blindsportsaustralia.com
      </Link>.
      </p>
    </Box>
  </Container>
);

export default Support;



// WEBPACK FOOTER //
// ./src/Support/Support.js